export default __webpack_public_path__ + "static/media/hipsters.9b1b8c3d.gif";